import isNull from "lodash/isNull";
import { auth, db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  where,
} from "../../Common/utils/firebaseFunctions";
import { SURVEY_QUESTIONNAIRE_COLLECTION } from "../../Common/domain/entities/features/surveyQuestionnaire/constants";
import { SurveyQuestionnaire } from "../../Common/domain/entities/features/surveyQuestionnaire/entity";

export const getSurveyQuestionnaireByChallengeKey = async (
  challengeKey: string
): Promise<SurveyQuestionnaire | null> => {
  const surveyQuery = await getDocs(
    query(
      collection(db, SURVEY_QUESTIONNAIRE_COLLECTION),
      where("challengeKey", "==", challengeKey),
      where("status", "==", "published")
    )
  );

  if (surveyQuery.docs.length === 0) {
    return null;
  }

  const doc = surveyQuery.docs[0];
  return { docId: doc.id, ...doc.data() } as SurveyQuestionnaire;
};
